import React, { createContext, useContext, useState } from 'react';

interface ThemeContextValue {
  dark: boolean;
  toggleDark: () => void;
}

const ThemeContext = createContext<ThemeContextValue>({ dark: false, toggleDark: () => undefined });

export function ThemeProvider({ children, defaultDark = false }: { children: React.ReactNode; defaultDark?: boolean }) {
  const [dark, setDark] = useState(defaultDark);
  return (
    <ThemeContext.Provider value={{ dark, toggleDark: () => setDark((d) => !d) }}>
      <div className={dark ? 'dark' : undefined}>{children}</div>
    </ThemeContext.Provider>
  );
}

export function useTheme(): ThemeContextValue {
  return useContext(ThemeContext);
}
